<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/phonenumbers"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="!editPhoneNumber.number || !editPhoneNumber.tenant"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ editPhoneNumber.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/phonenumbers')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
							<!-- <p class="textSml textGrey fontHeavy textUppercase">User</p> -->
						</div>
					</div>
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div
										v-if="editPhoneNumber.id"
										class="flex w-full flex-col items-center justify-center gap-2"
									>
										<div class="flex items-center gap-3">
											<span class="fa-light fa-phone leading-none text-primary"></span>
											<h1 class="leading-none">{{ editPhoneNumber.number }}</h1>

											<div class="relative">
												<button
													ref="searchCallsButton"
													class="group flex h-6 w-6 items-center justify-center rounded-full bg-blue-50 text-blue-700 shadow-sm transition-all duration-200 hover:bg-blue-100 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 active:scale-95 dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/40"
													title="Search for calls involving this number"
													@click="toggleSearchCallsDropdown"
												>
													<span
														class="fa-light fa-magnifying-glass text-xs transition-transform group-hover:scale-110"
													></span>
												</button>

												<div
													v-if="searchCallsDropdownVisible"
													class="absolute right-0 top-full z-50 mt-2 w-80 rounded-xl border border-gray-200 bg-white shadow-xl dark:border-gray-600 dark:bg-gray-800"
												>
													<div class="p-6">
														<div class="mb-4 flex items-center gap-2">
															<span
																class="fa-light fa-magnifying-glass text-blue-600 dark:text-blue-400"
															></span>
															<h4 class="font-semibold text-gray-900 dark:text-white">
																Search Calls
															</h4>
														</div>

														<div class="mb-5">
															<label
																class="mb-3 block text-sm font-medium text-gray-700 dark:text-gray-300"
																>Search Type</label
															>
															<div class="grid grid-cols-1 gap-2">
																<button
																	class="flex items-center rounded-lg border border-gray-200 px-4 py-3 text-left text-sm transition-all hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-700"
																	:class="{
																		'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-600 dark:bg-blue-900/30 dark:text-blue-300':
																			selectedSearchType === 'all'
																	}"
																	@click="selectedSearchType = 'all'"
																>
																	<span
																		class="fa-light fa-phone-rotary mr-3 text-base"
																	></span>
																	<div>
																		<div class="font-medium">All Calls</div>
																		<div
																			class="text-xs text-gray-500 dark:text-gray-400"
																		>
																			Any direction (incoming or outgoing)
																		</div>
																	</div>
																</button>
																<button
																	class="flex items-center rounded-lg border border-gray-200 px-4 py-3 text-left text-sm transition-all hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-700"
																	:class="{
																		'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-600 dark:bg-blue-900/30 dark:text-blue-300':
																			selectedSearchType === 'incoming'
																	}"
																	@click="selectedSearchType = 'incoming'"
																>
																	<span
																		class="fa-light fa-phone-incoming mr-3 text-base"
																	></span>
																	<div>
																		<div class="font-medium">Incoming Calls</div>
																		<div
																			class="text-xs text-gray-500 dark:text-gray-400"
																		>
																			Calls received by this number
																		</div>
																	</div>
																</button>
																<button
																	class="flex items-center rounded-lg border border-gray-200 px-4 py-3 text-left text-sm transition-all hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-700"
																	:class="{
																		'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-600 dark:bg-blue-900/30 dark:text-blue-300':
																			selectedSearchType === 'outgoing'
																	}"
																	@click="selectedSearchType = 'outgoing'"
																>
																	<span
																		class="fa-light fa-phone-outgoing mr-3 text-base"
																	></span>
																	<div>
																		<div class="font-medium">Outgoing Calls</div>
																		<div
																			class="text-xs text-gray-500 dark:text-gray-400"
																		>
																			Calls made from this number
																		</div>
																	</div>
																</button>
															</div>
														</div>

														<div
															v-if="
																editPhoneNumber.itf_mal_number ||
																editPhoneNumber.itf_pal_number
															"
															class="mb-5"
														>
															<label
																class="mb-3 block text-sm font-medium text-gray-700 dark:text-gray-300"
																>Number Variant</label
															>
															<div class="space-y-3">
																<label class="group flex cursor-pointer items-center">
																	<input
																		v-model="selectedNumberType"
																		type="radio"
																		value="main"
																		class="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500"
																	/>
																	<div class="flex-1">
																		<div
																			class="text-sm font-medium text-gray-900 dark:text-white"
																		>
																			Main Number
																		</div>
																		<div
																			class="text-sm text-gray-600 dark:text-gray-300"
																		>
																			{{ editPhoneNumber.number }}
																		</div>
																	</div>
																</label>
																<label
																	v-if="editPhoneNumber.itf_mal_number"
																	class="group flex cursor-pointer items-center"
																>
																	<input
																		v-model="selectedNumberType"
																		type="radio"
																		value="mal"
																		class="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500"
																	/>
																	<div class="flex-1">
																		<div
																			class="text-sm font-medium text-gray-900 dark:text-white"
																		>
																			MAL Number
																		</div>
																		<div
																			class="text-sm text-gray-600 dark:text-gray-300"
																		>
																			{{ editPhoneNumber.itf_mal_number }}
																		</div>
																	</div>
																</label>
																<label
																	v-if="editPhoneNumber.itf_pal_number"
																	class="group flex cursor-pointer items-center"
																>
																	<input
																		v-model="selectedNumberType"
																		type="radio"
																		value="pal"
																		class="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500"
																	/>
																	<div class="flex-1">
																		<div
																			class="text-sm font-medium text-gray-900 dark:text-white"
																		>
																			PAL Number
																		</div>
																		<div
																			class="text-sm text-gray-600 dark:text-gray-300"
																		>
																			{{ editPhoneNumber.itf_pal_number }}
																		</div>
																	</div>
																</label>
															</div>
														</div>

														<div class="mb-6">
															<label
																class="mb-3 block text-sm font-medium text-gray-700 dark:text-gray-300"
																>Time Range</label
															>
															<select
																v-model="selectedTimeRange"
																class="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:focus:border-blue-400"
															>
																<option value="last24h">Last 24 Hours</option>
																<option value="lastWeek">Last Week</option>
																<option value="last30d">Last 30 Days</option>
																<option value="thisMonth">This Month</option>
																<option value="lastMonth">Last Month</option>
															</select>
														</div>

														<div class="flex gap-3">
															<button
																class="flex-1 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
																@click="executeSearchCalls"
															>
																<span class="fa-light fa-magnifying-glass mr-2"></span>
																Search Calls
															</button>
															<button
																class="rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
																@click="searchCallsDropdownVisible = false"
															>
																Cancel
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="flex flex-wrap items-center justify-center gap-4">
											<div
												v-if="editPhoneNumber.itf_mal_number"
												class="flex items-center gap-1 text-sm opacity-70"
											>
												<span class="font-bold text-offmaindark dark:text-primary">MAL</span>
												<h2>{{ editPhoneNumber.itf_mal_number }}</h2>
											</div>
											<div
												v-if="editPhoneNumber.itf_pal_number"
												class="flex items-center gap-1 text-sm opacity-70"
											>
												<span class="font-bold text-offmaindark dark:text-primary">PAL</span>
												<h2>{{ editPhoneNumber.itf_pal_number }}</h2>
											</div>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">General</h3>
									</div>
									<div v-if="!editPhoneNumber.id" class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Number</label>
											<FormKit
												v-model="editPhoneNumber.number"
												type="text"
												class="form-control"
												placeholder="01234567890"
												name="number"
												:validation="[['required'], ['matches', /^\+?[0-9]\d{9,16}$/]]"
												:validation-messages="{ matches: 'Must be a valid phone number' }"
												validation-visibility="live"
												:disabled="!!editPhoneNumber.id"
											/>
										</div>
										<div
											v-if="$global.hasUserRole(userRoles, 'phonenumbers:itf')"
											class="flex items-center"
										>
											<form-field label="Use MAL/PAL Variants">
												<input
													v-model="editPhoneNumber.itf"
													type="checkbox"
													class="tw-toggle ml-2"
												/>
											</form-field>
										</div>
										<div v-if="editPhoneNumber.itf" class="flex gap-4">
											<div class="formGroup flex-1">
												<label class="textGrey">MAL Number</label>
												<FormKit
													v-model="editPhoneNumber.itf_mal_number"
													type="text"
													class="form-control"
													placeholder="Enter MAL Number"
													name="mal_number"
													:validation="[['matches', /^\+?[0-9]\d{9,16}$/]]"
													:validation-messages="{ matches: 'Must be a valid phone number' }"
													validation-visibility="live"
												/>
											</div>
											<div class="formGroup flex-1">
												<label class="textGrey">PAL Number</label>
												<FormKit
													v-model="editPhoneNumber.itf_pal_number"
													type="text"
													class="form-control"
													placeholder="Enter PAL Number"
													name="pal_number"
													:validation="[['matches', /^\+?[0-9]\d{9,16}$/]]"
													:validation-messages="{ matches: 'Must be a valid phone number' }"
													validation-visibility="live"
												/>
											</div>
										</div>
									</div>
									<div
										v-if="
											!editPhoneNumber.id &&
											(tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller'))
										"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<div class="formGroup withIcon">
											<label class="textGrey">Tenant</label>
											<SearchableDropdown
												v-model="editPhoneNumber.tenant"
												:options="tenants.map((t) => ({ value: t, label: t.companyName }))"
												label=""
												placeholder="-- Select Tenant --"
												:is-searchable="true"
												:multi-select="false"
												@change="
													((editPhoneNumber.accountId = undefined),
													(editPhoneNumber.account = undefined))
												"
											/>
										</div>
									</div>
									<div
										v-if="editPhoneNumber.tenant && !userRoles.includes('account')"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<div class="formGroup withIcon">
											<a
												class="group flex cursor-pointer gap-1"
												:href="
													editPhoneNumber.accountId || !editPhoneNumber.accountId === null
														? `/accounts/${editPhoneNumber.accountId}`
														: 'javascript:void(0);'
												"
												:target="
													editPhoneNumber.accountId || !editPhoneNumber.accountId === null
														? `_blank`
														: ''
												"
											>
												<label class="textGrey cursor-pointer group-hover:underline"
													>Account</label
												>
												<svg
													v-if="
														editPhoneNumber.accountId || !editPhoneNumber.accountId === null
													"
													class="mt-1"
													width="14"
													height="14"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z" fill="currentColor" />
													<path
														d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
														fill="currentColor"
													/>
												</svg>
											</a>
											<SearchableDropdown
												v-model="editPhoneNumber.accountId"
												:options="
													tenantAccounts.map((a) => ({ value: a.id, label: a.name, ...a }))
												"
												label=""
												placeholder="-- Select Account --"
												:is-searchable="true"
												:multi-select="false"
												@change="accountChanged"
											/>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Caller ID</h3>
									</div>
									<div class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey"
												>Caller ID Name (supported in North America, and SIP trunking)</label
											>
											<input
												v-model="editPhoneNumber.callerIdName"
												type="text"
												class="form-control"
												placeholder="Enter caller ID name"
											/>
										</div>
									</div>
									<application-config
										v-if="editPhoneNumber.tenant"
										v-model="editPhoneNumber"
										:account="selectedAccount"
									/>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Number Options</h3>
									</div>
									<div class="mb-4 grid w-full gap-4 px-2 md:grid-cols-2 lg:grid-cols-3">
										<div
											class="flex items-center justify-between rounded-lg border border-gray-200 p-4 dark:border-gray-700"
											@click="editPhoneNumber.blockPayphone = !editPhoneNumber.blockPayphone"
										>
											<label class="text-sm text-gray-700 dark:text-[#d9d9d9]"
												>Block Payphone Calls</label
											>
											<input
												v-model="editPhoneNumber.blockPayphone"
												type="checkbox"
												class="tw-toggle"
											/>
										</div>
										<div
											class="flex items-center justify-between rounded-lg border border-gray-200 p-4 dark:border-gray-700"
											@click="editPhoneNumber.blockWithheld = !editPhoneNumber.blockWithheld"
										>
											<label class="text-sm text-gray-700 dark:text-[#d9d9d9]"
												>Block Withheld / Invalid CLI</label
											>
											<input
												v-model="editPhoneNumber.blockWithheld"
												type="checkbox"
												class="tw-toggle"
											/>
										</div>
										<div
											class="flex items-center justify-between rounded-lg border border-gray-200 p-4 dark:border-gray-700"
											@click="
												editPhoneNumber.blockInternational = !editPhoneNumber.blockInternational
											"
										>
											<label class="text-sm text-gray-700 dark:text-[#d9d9d9]"
												>Block International Calls</label
											>
											<input
												v-model="editPhoneNumber.blockInternational"
												type="checkbox"
												class="tw-toggle"
											/>
										</div>
									</div>
									<div class="mb-2 flex w-full flex-row md:mb-5">
										<div class="flex w-1/2 flex-col px-2">
											<div class="formGroup">
												<label class="textGrey">Max Duration (Minutes)</label>
												<input
													v-model="editPhoneNumber.maxDurationMins"
													type="text"
													class="form-control"
												/>
											</div>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Other</h3>
									</div>
									<div class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Description</label>
											<input
												v-model="editPhoneNumber.description"
												type="text"
												class="form-control"
												placeholder="Enter description (optional)"
											/>
										</div>
									</div>
									<div class="margin-b20 flex px-2">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="!editPhoneNumber.number || !editPhoneNumber.tenant"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ editPhoneNumber.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/phonenumbers')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import phoneNumbersApi from '../scripts/phonenumbers/phonenumbers.api.js'
import { router } from '../router/index.js'
import accountsApi from '../scripts/accounts/accounts.api'
import SearchableDropdown from '../components/common/SearchableDropdown.vue'

export default {
	components: {
		SearchableDropdown
	},
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editPhoneNumber: {
				number: '',
				tenant: null,
				itf: false,
				itf_mal_number: '',
				itf_pal_number: '',
				maxDurationMins: '240',
				app: null,
				accountId: undefined,
				description: '',
				appConfig: {
					call_forwarding: {
						destination: '',
						cli_preference: 'AS_RECEIVED'
					},
					sip_trunk: {
						trunkId: null
					},
					mobile_sim: {
						simId: null
					},
					prompt_then_forward: {
						destination: '',
						cli_preference: 'AS_RECEIVED',
						fileId: null
					},
					flows: {
						flowId: null
					},
					play_prompt: {
						fileId: null
					},
					dial_thru: {
						welcomePromptFileId: null
					}
				},
				account: null,
				blockPayphone: true
			},
			accounts: [],
			loading: true,
			searchCallsDropdownVisible: false,
			selectedSearchType: 'all',
			selectedNumberType: 'main',
			selectedTimeRange: 'last30d'
		}
	},

	computed: {
		tenantAccounts() {
			if (!this.editPhoneNumber.tenant) return []
			const tenantId = this.editPhoneNumber.tenant.id
			return this.accounts
				.filter((a) => a.tenant && a.tenant.id === tenantId)
				.sort((a, b) => a.name.localeCompare(b.name))
		},
		selectedAccount() {
			return this.accounts.find((a) => a.id === this.editPhoneNumber.accountId)
		}
	},

	async created() {
		try {
			const accountsResult = accountsApi.getAll({ limit: 2500 })

			if (this.$route.params.id !== 'new') {
				const result = await phoneNumbersApi.getById(this.$route.params.id)
				this.editPhoneNumber = result.data
				if (this.editPhoneNumber.account) {
					this.editPhoneNumber.accountId = this.editPhoneNumber.account.id
					if (this.editPhoneNumber.account.tenant) {
						const tenantObj = this.tenants.find((t) => t.id === this.editPhoneNumber.account.tenant.id)
						this.editPhoneNumber.tenant = tenantObj || this.editPhoneNumber.account.tenant
					}
				} else if (this.editPhoneNumber.tenant) {
					const tenantObj = this.tenants.find((t) => t.id === this.editPhoneNumber.tenant.id)
					this.editPhoneNumber.tenant = tenantObj || this.editPhoneNumber.tenant
				}
			} else if (this.tenants?.length === 1) {
				this.editPhoneNumber.tenant = this.tenants[0]
			}
			this.editPhoneNumber.appConfig = this.editPhoneNumber.appConfig || {}
			this.accounts = (await accountsResult).data.results.sort((a, b) => a.name.localeCompare(b.name))

			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading phone number',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/phonenumbers')
			})
			console.error(e)
		}
	},

	mounted() {
		document.addEventListener('click', this.handleClickOutsideSearchDropdown)
	},

	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutsideSearchDropdown)
	},

	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			if (this.editPhoneNumber.accountId) {
				const account = this.accounts.find((a) => a.id === this.editPhoneNumber.accountId)
				this.editPhoneNumber.account = account
				if (account && account.tenant) {
					this.editPhoneNumber.tenant = account.tenant
				}
			}

			if (!this.editPhoneNumber.id) {
				phoneNumbersApi.create(this.editPhoneNumber).then(this.onSave).catch(console.error)
			} else {
				phoneNumbersApi.update(this.editPhoneNumber).then(this.onSave).catch(console.error)
			}
		},
		onSave(result) {
			if (result.success === false) {
				if (result.error === 'Duplicate entry') {
					this.$swal({
						title: 'Duplicate Number',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'This number is already configured. Please choose another.'
					})
				} else if (result.error?.indexOf(`Field 'number_e164' doesn't have a default value`) > -1) {
					this.$swal({
						title: 'Invalid Number',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'Invalid number format, please try again.'
					})
				} else {
					this.$swal({
						title: 'Error Occurred',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'Unknown error occurred, please try again or contact support.'
					})
				}
			} else this.routeTo('/phonenumbers')
		},
		handleTenantChange(value) {
			this.editPhoneNumber.tenant = value
			this.editPhoneNumber.accountId = undefined
			this.editPhoneNumber.account = undefined
		},
		handleAccountChange(value) {
			this.editPhoneNumber.accountId = value
		},
		accountChanged(value) {
			this.editPhoneNumber.accountId = value
			const account = this.accounts.find((a) => a.id === value)
			if (account) {
				this.editPhoneNumber.account = account
			}
		},
		toggleSearchCallsDropdown() {
			this.searchCallsDropdownVisible = !this.searchCallsDropdownVisible
		},
		executeSearchCalls() {
			const params = new URLSearchParams()

			let searchNumber = this.editPhoneNumber.number

			if (this.selectedNumberType === 'mal' && this.editPhoneNumber.itf_mal_number) {
				searchNumber = this.editPhoneNumber.itf_mal_number
			} else if (this.selectedNumberType === 'pal' && this.editPhoneNumber.itf_pal_number) {
				searchNumber = this.editPhoneNumber.itf_pal_number
			}

			if (this.selectedSearchType === 'all') {
				params.set('callAnywhere', searchNumber)
			} else if (this.selectedSearchType === 'incoming') {
				params.set('callTo', searchNumber)
			} else if (this.selectedSearchType === 'outgoing') {
				params.set('callFrom', searchNumber)
			}

			if (this.editPhoneNumber.tenant?.id) {
				params.set('tenant', this.editPhoneNumber.tenant.id)
			}

			if (this.editPhoneNumber.account?.id) {
				params.set('account', this.editPhoneNumber.account.id)
			}

			params.set('preset', this.selectedTimeRange)

			const url = `/calls?${params.toString()}`

			this.searchCallsDropdownVisible = false
			window.open(url, '_blank')
		},
		handleClickOutsideSearchDropdown(event) {
			if (
				this.$refs.searchCallsButton &&
				!this.$refs.searchCallsButton.contains(event.target) &&
				!event.target.closest('.absolute')
			) {
				this.searchCallsDropdownVisible = false
			}
		}
	}
}
</script>
